import React from 'react'
import LazyLoad from 'react-lazyload'
import { sprintf } from 'sprintf-js'
import UrlManager from '~/util/url_manager'
import Util from '@hikakaku/shared/util/util'
import { format } from 'date-fns'
import _ from 'lodash'
import qs from 'qs'
import classNames from 'classnames'
import { toCamelcaseKeys } from '@hikakaku/shared/util/convert_case_keys'
import { toDate } from '@hikakaku/shared/util/date_util'
import KaitoriHistoryItems from '~/components/single_products/kaitori_history_items'

const HIGHEST_PRICE_ERROR_VALUE = -9999
const RANKING_STORES_PER_PAGE = 10

class RankingCellSingleProduct extends React.Component {
  get MAX_TEXT_NUM_POSTAGE() {
    return 70 //送料のテキスト最大文字数
  }

  get MAX_TEXT_NUM_REMARKS() {
    return 70 //備考のテキスト最大文字数
  }

  get MAX_TEXT_NUM_REPORT()	{
    return 70 //特記事項のテキスト最大文字数
  }

  get CV_BTN_WIDE()	{
    return '/wp-content/themes/hikakaku_theme/images/cv_btn_wide.png'
  }
  get CV_BTN_BLUE()	{
    return '/wp-content/themes/hikakaku_theme/images/btn_cv_bu_bold.png'
  }
  get CV_BTN_WIDE_BOLD() {
    return '/wp-content/themes/hikakaku_theme/images/cv_btn_wide_bold.png'
  }
  get CV_BTN_DEFAULT() {
    return 'https://contents.hikakaku.com/public/wp-content/uploads/2014/09/kokode.png'
  }
  get STORE_NOIMAGE_PATH() {
    return '/wp-content/themes/hikakaku_theme/images/company_noimage.jpg'
  }

  get ESTIMATE_BUTTON_TEXT() {
    return "無料で査定依頼する"
  }
  get CLICK_CONVERSION_BUTTON_TEXT() {
    return "公式サイトへ"
  }
  get DETAIL_BUTTON_TEXT() {
    return "詳細へ"
  }

  get GA_ESTIMATE_FORM_POP() {
    return "サイト内無料見積りフォーム click フォーム起動"
  }
  get GA_CLICK_TRANSFER_EVENT() {
    return "クリック送客(契約業者) click 無料見積りボタン"
  }
  get GA_AFFILIATE_EVENT() {
    return "クリック送客(アフィ) click 無料見積りボタン"
  }
  get GA_NO_CONTRACT_EVENT() {
    return "クリック送客(非契約業者) click 無料見積りボタン"
  }

  constructor(props) {
    super(props)
    this.state = {
    }
  }

  hasActiveEstimateForm() {
    return this.props.data.store.store_contract.assessment_form && !this.props.data.store.suspended_estimate_form
  }

  showEstimateFormButton() {
    return !this.props.data.store.store_contract.cv_click_transfer_first && this.hasActiveEstimateForm()
  }

  hasActiveClickTransfer() {
    return this.props.data.store.store_contract.click_transfer && !this.props.data.store.suspended_click_transfer
  }

  getPriceObj() {
    let priceObj
    if (this.props.data.price <= 1) {
      priceObj = (
        <span className="si-result__price">
          <span className="item__ranking__cell__info__failed_price">
            要見積もり
          </span>
        </span>
      )
    } else {
      priceObj = (
        <span>
          <span className="item__ranking__cell__info__currency_unit">〜¥</span>
          <span className="item__ranking__cell__info__price">{this.props.data.price.toLocaleString()}</span>
        </span>
      )
    }
    return priceObj
  }

  getCreatedTime() {
    const priceCreatedAt = toDate(this.props.data.price_created_at)
    if (this.props.data.price <= 1 || !priceCreatedAt) {
      return ''
    } else {
      const createdTime = format(priceCreatedAt, 'yyyy/M/d')
      return (
        <span className="created-time co-gray-2 fnt-size-8">({createdTime}時点)</span>
      )
    }
  }

  renderShopLink() {
    if (this.showEstimateFormButton()) {
      return this.getAssessmentPopupTag()
    } else if (this.hasActiveClickTransfer()) {
      return this.getClickConversionLinkTag()
    } else {
      return this.getDetailLinkTag()
    }
  }

  getSpecialNotes() {
    let ret = this.props.data.store.special_notes
    ret = Util.substr(ret, this.MAX_TEXT_NUM_REPORT)
    return ret
  }

  getPostage() {
    let ret = this.props.data.store.postage
    ret = Util.substr(ret, this.MAX_TEXT_NUM_POSTAGE)
    return ret
  }

  getPostageAttention() {
    let ret = this.props.data.store.postage_attention
    ret = Util.substr(ret, this.MAX_TEXT_NUM_REMARKS)
    return ret
  }

  getRankingBadge(rank) {

    switch (rank) {
    case 1: {
      return 'gold'
    }
    case 2: {
      return 'silver'
    }
    case 3: {
      return 'bronze'
    }
    default: {
      return 'normal'
    }
    }
  }

  getStoreLinkPath() {
    return `/company/${this.props.data.store.id}/`
  }

  renderCVBtnsSP() {
    let store = this.props.data.store
    let btn_class = store.is_phone_open ? "" : " wide"
    return (
      <div className="item__ranking__cell__cv">
        <div className={"item__ranking__cell__cv__btn" + btn_class}>
          {this.renderShopLink()}
        </div>
        {this.renderTelSP()}
      </div>
    )
  }

  renderTelSP() {
    let store = this.props.data.store
    if (store.is_phone_open === false) {
      return
    }
    return (
      <div className="item__ranking__cell__cv__tel">
        <a className="item__ranking__cell__cv__tel__text" href={"tel:" + store.phone_number}
          data-analytics-track-event={"電話（お問い合わせ） click"} >
          <div className="item__ranking__cell__cv__tel__btn">
            <div className="i fa fa-phone-volume item__ranking__cell__cv__tel__phone_icon" />
            電話をかける
          </div>
        </a>
        <p className="item__ranking__cell__cv__tel__time">
          受付時間: {store.phone_open_time}〜{store.phone_close_time}
        </p>
      </div>
    )
  }

  renderTelPC() {
    let store = this.props.data.store
    if (store.is_phone_open === false) {
      return
    }
    return (
      <div className="item__ranking__cell__cv__tel">
        <div className="item__ranking__cell__cv__tel__btn">
          <div className="item__ranking__cell__cv__tel__text">
            <div className="i fa fa-phone-volume item__ranking__cell__cv__tel__phone_icon" />
            {store.phone_number}
            <p className="item__ranking__cell__cv__tel__time">
              受付時間: {store.phone_open_time}〜{store.phone_close_time}
            </p>
          </div>
        </div>
      </div>
    )
  }

  getClickConversionLinkTag() {
    const link = this.hasActiveClickTransfer()
      ? this.props.data.store.store_contract.click_transfer_path
      : this.props.data.store.link_url
    return (
      <a href={link}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="sw-LegacyButton sw-LegacyButton-fixed sw-LegacyButton-orange"
        data-analytics-track-event={this.getGAEvent()}>
        {this.CLICK_CONVERSION_BUTTON_TEXT}
      </a>
    )
  }

  getDetailLinkTag() {
    return (
      <a href={this.props.data.store.detail_page_path} className="sw-LegacyButton sw-LegacyButton-fixed sw-LegacyButton-blue">
        {this.DETAIL_BUTTON_TEXT}
      </a>
    )
  }

  /*査定フォームのポップアップタグ*/
  getAssessmentPopupTag() {
    const form_query = qs.stringify({
      store_id: this.props.data.store.id,
      item_id: this.props.item.id
    })
    return (
      <span>
        <a href={`/store_estimate_form/?${form_query}` }
          data-analytics-track-event={this.getGAEvent()}
          rel="nofollow"
          className="sw-LegacyButton sw-LegacyButton-fixed sw-LegacyButton-red">
          {this.ESTIMATE_BUTTON_TEXT}
        </a>
        <span data-jet_imp="page_ass_btn_imp-product_page" data-jet_options={"{\"company_id\":\"" + this.props.data.store.post_id + "\"}"} data-jet_settings={"{\"is_insert_once\":true}"} >
        </span>
      </span>
    )
  }

  getGAEvent() {
    const contract = this.props.data.store.store_contract
    if (contract.assessment_form) {
      return this.GA_ESTIMATE_FORM_POP
    } else if (contract.click_transfer) {
      return `${this.GA_CLICK_TRANSFER_EVENT} ${contract.cost_per_click}`
    } else if (contract.affiliate) {
      return this.GA_AFFILIATE_EVENT
    } else {
      return this.GA_NO_CONTRACT_EVENT
    }
  }

  renderAssessmentCountInner() {
    let store = this.props.data.store
    return (
      <p className="item__ranking__cell__assessment__num">
        {store.achievement_count}件
      </p>
    )
  }

  renderAssessmentCount() {
    let store = this.props.data.store
    if (store.achievement_count < 1) {
      return this.renderAssessmentCountInner()
    }

    return (
      <a href={UrlManager.getStoreAssessmentAchievementsPath(store.id)} >
        {this.renderAssessmentCountInner()}
      </a>
    )
  }

  createStarRatingClass() {
    let store = this.props.data.store
    let rating = Util.roundHalf(store.rating)
    rating = sprintf('%.1f', rating)
    rating = rating.replace('.', '-')
    let ret = 's' + rating
    return ret
  }

  getStoreImageUrl() {
    let store = this.props.data.store
    let url = store.logo_url
    if (typeof url !== 'string' || url.length < 1) {
      return this.STORE_NOIMAGE_PATH
    }
    return store.logo_url
  }

  createImageNone() {
    const ids = this.props.item.category_ids

    return (
      <div className={classNames('taxonomy', 'thumb_wrapper', 'hover_bg', ids.map((id) => `id${id}`))}>
        <div className={classNames('taxonomy', 'thumb', 'icon', ids.map((id) => `id${id}`))}>
        </div>
      </div>
    )
  }

  getKaitoriHistoriesByStore() {
    const props = toCamelcaseKeys({
      histories: this.props.data.kaitori_histories.map((history) => ({
        ...history,
        estimateFormPath: "/estimate_form?import_category_id=" + this.props.item.import_category_id
      }))
    })
    if (props.histories.length === 0) { return }

    // eslint-disable-next-line consistent-return
    return <KaitoriHistoryItems {...props}/>
  }

  getRenderSP() {
    let review_rate_star_style = {
      width: "100px",
      textAlign: "center"
    }
    let store = this.props.data.store

    return (
      <li key={store.id} className={"item__ranking__cell__" + this.getRankingBadge(this.props.index + 1) + "_border"}>

        <div className="flex">
          <div className="item__ranking__cell__badge">
            {this.props.pr ? (
              <div className="item__ranking__cell__badge__pr">
                PR
              </div>
            ) : (
              <div className={"item__ranking__cell__badge__" + this.getRankingBadge(this.props.index + 1)}>
                {this.props.index + 1}
              </div>
            )}
          </div>
          <span className="item__ranking__cell__name__text">
            <a href={this.getStoreLinkPath()}>
              {store.name}
            </a>
          </span>
        </div>

        <div className="item__ranking__cell__name block">

          <a href={this.getStoreLinkPath()}>
            <div className="item__ranking__cell__name__thumb">
              <LazyLoad height={80} style={{height: '80px'}}once>
                <img alt={store.name} src={this.getStoreImageUrl()} className="lazyload" />
              </LazyLoad>

              <div>
                <div className="item__ranking__cell__review">
                  <div className="item__ranking__cell__review__star-wrapper">
                    <div className={"review__stars xs block-center " + this.createStarRatingClass()} >
                    </div>
                  </div>
                  <div className="review_rate_number fnt-size-10 co-red">
                    {store.rating}
                  </div>
                  <div className="co-black fnt-size-6">
                    {"(" + store.review_count + "件のクチコミ)"}
                  </div>
                </div>

                <div className="item__ranking__cell__satisfaction_rate">
                  {Math.round(store.satisfaction_rate * 100)}%の人が査定結果に満足しています
                </div>

                <div className="item__ranking__cell__shopstyle">
                  <span className={"si-result__keishiki si-result__keishiki--type-" + ((store.purchase_method.substr(0, 1) === "1") ? "true" : "false")}>
                    宅配
                  </span>
                  <span className={"si-result__keishiki si-result__keishiki--type-" + ((store.purchase_method.substr(1, 1) === "1") ? "true" : "false")}>
                    店頭
                  </span>
                  <span className={"si-result__keishiki si-result__keishiki--type-" + ((store.purchase_method.substr(2, 1) === "1") ? "true" : "false")}>
                    出張
                  </span>
                </div>
              </div>
            </div>
          </a>

        </div>


        <div className="item__ranking__cell__maininfo block">

          <div className="item__ranking__cell__info">
            <h3 className="item__ranking__cell__title">
              最高買取価格
            </h3>
            <p className="item__ranking__cell__info__price_field">
              {this.getPriceObj()}
            </p>
            <p className="item__ranking__cell__info__createdtime">
              {this.getCreatedTime()}
            </p>
          </div>

          <div className="item__ranking__cell__info">
            <h3 className="item__ranking__cell__title">
              送料
            </h3>
            <div>
              <p className="item__ranking__cell__info__text">
                {this.getPostage()}
              </p>
              <p className="item__ranking__cell__info__text__postage_attention">
                {this.getPostageAttention()}
              </p>
            </div>
          </div>

          <div className="item__ranking__cell__info">
            <h3 className="item__ranking__cell__title">
              特記事項
            </h3>
            <p className="item__ranking__cell__info__text__note">
              {this.getSpecialNotes()}
            </p>
          </div>

          <div className="item__ranking__cell__info">
            <div className="item__ranking__cell__assessment">
              <div className="flex">
                <h3 className="item__ranking__cell__title">
                  査定実績
                </h3>
                {this.renderAssessmentCount()}
              </div>
              {this.getKaitoriHistoriesByStore()}
            </div>
          </div>
        </div>

        {this.renderCVBtnsSP()}

      </li>
    )
  }


  getRenderPC() {
    let review_rate_star_style = {
      width: "100%",
      textAlign: "center"
    }

    let store = this.props.data.store

    return (
      <li key={store.id} className="item__ranking__cell">

        <div className="flex">
          <div className="item__ranking__cell__badge">
            {this.props.pr ? (
              <div className="item__ranking__cell__badge__pr">
                PR
              </div>
            ) : (
              <div className={"item__ranking__cell__badge__" + this.getRankingBadge(this.props.index + 1)}>
                {this.props.index + 1}
              </div>
            )}
          </div>
          <span className="item__ranking__cell__name__text">
            <a href={this.getStoreLinkPath()}>
              {store.name}
            </a>
          </span>

          <div className="item__ranking__cell__cv__block">
            <div className="item__ranking__cell__cv__btn">
              {this.renderShopLink()}
            </div>
            {this.renderTelPC()}
          </div>
        </div>

        <a href={this.getStoreLinkPath()}>
          <div className="item__ranking__cell__name block">
            <div className="item__ranking__cell__name__thumb">
              <LazyLoad height={80} style={{height: '80px'}}once>
                <img alt={store.name} src={this.getStoreImageUrl()} className="lazyload" />
              </LazyLoad>
            </div>

            <div className="item__ranking__cell__review">
              <div className="item__ranking__cell__review__star-wrapper">
                <div className={"review__stars xs block-center " + this.createStarRatingClass()} >
                </div>
              </div>
              <div className="review_rate_number fnt-size-10 co-red">
                {store.rating}
              </div>
              <div className="co-black fnt-size-6">
                {"(" + store.review_count + "件のクチコミ)"}
              </div>
            </div>

            <div className="item__ranking__cell__satisfaction_rate">
              {Math.round(store.satisfaction_rate * 100)}%の人が査定結果に満足しています
            </div>

            <div className="item__ranking__cell__shopstyle">
              <span className={"si-result__keishiki si-result__keishiki--type-" + ((store.purchase_method.substr(0, 1) === "1") ? "true" : "false")}>
                宅配
              </span>
              <span className={"si-result__keishiki si-result__keishiki--type-" + ((store.purchase_method.substr(1, 1) === "1") ? "true" : "false")}>
                店頭
              </span>
              <span className={"si-result__keishiki si-result__keishiki--type-" + ((store.purchase_method.substr(2, 1) === "1") ? "true" : "false")}>
                出張
              </span>
            </div>
          </div>
        </a>


        <div className="item__ranking__cell__maininfo block">

          <div className="item__ranking__cell__info">
            <h3 className="item__ranking__cell__title">
              最高買取価格
            </h3>
            <p className="item__ranking__cell__info__price_field">
              {this.getPriceObj()}
            </p>
            <div className="item__ranking__cell__info__createdtime">
              {this.getCreatedTime()}
            </div>
          </div>

          <div className="item__ranking__cell__info">
            <h3 className="item__ranking__cell__title">
              送料
            </h3>
            <div>
              <p className="item__ranking__cell__info__text">
                {this.getPostage()}
              </p>
              <p className="item__ranking__cell__info__text__postage_attention">
                {this.getPostageAttention()}
              </p>
            </div>
          </div>

          <div className="item__ranking__cell__info">
            <h3 className="item__ranking__cell__title">
              特記事項
            </h3>
            <p className="item__ranking__cell__info__text__note">
              {this.getSpecialNotes()}
            </p>
          </div>

          <div className="item__ranking__cell__info">
            <div className="item__ranking__cell__assessment">
              <div className="flex">
                <h3 className="item__ranking__cell__title">
                  査定実績
                </h3>
                {this.renderAssessmentCount()}
              </div>
              {this.getKaitoriHistoriesByStore()}
            </div>
          </div>
        </div>

      </li>
    )
  }

  render() {
    if (typeof this.props.isMobile === "undefined" ||
      this.props.isMobile === null) {
      return this.getRenderPC()
    } else {
      return this.getRenderSP()
    }
  }
}

class RankingListSingleProduct extends React.Component {

  get RECOMMEND_SORT_LABEL() {
    return "おすすめ順"
  }
  get PRICE_SORT_LABEL() {
    return "上限買取価格順"
  }
  get REVIEW_SORT_LABEL() {
    return "評価順"
  }

  constructor(props) {
    super(props)

    const count = RANKING_STORES_PER_PAGE
    const initialPrices = props.data && props.data.prices ? props.data.prices : []
    const totalCount = (props.data && props.data.total_prices_count != null)
      ? props.data.total_prices_count
      : initialPrices.length

    this.state = {
      highestPriceErrorVal: HIGHEST_PRICE_ERROR_VALUE,
      highestPrice: this.calcHighestPrice(initialPrices),
      currentSortKey: "",
      sortKeys: {
        review: "store.rating",
        price: "price",
      },
      maxShowCount: count,
      loadCount: count,
      pricesBySort: {
        recommend: initialPrices,
        price: [],
        review: [],
      },
      totalCount: totalCount,
      loading: false,
      pageBySort: { recommend: 1, price: 0, review: 0 },
    }

    this.resetSort = this.resetSort.bind(this)
    this.sortByReview = this.sortByReview.bind(this)
    this.sortByPrice = this.sortByPrice.bind(this)
    this.onLoadBtnClick = this.onLoadBtnClick.bind(this)
    this.fetchRankingStores = this.fetchRankingStores.bind(this)
  }

  setInitialProps() {
    return {}
  }

  calcHighestPrice(pricesList) {
    if (!pricesList || pricesList.length === 0) return HIGHEST_PRICE_ERROR_VALUE
    const priceList = Util.objectArraySort(_.cloneDeep(pricesList), "price")
    return priceList[0].price
  }

  getCurrentList() {
    if (!this.getRankingStoresPath()) {
      const sortKey = this.state.sortKeys[this.state.currentSortKey]
      const raw = this.props.data.prices || []
      return sortKey ? Util.objectArraySort(_.cloneDeep(raw), sortKey) : raw
    }
    const key = this.state.currentSortKey || "recommend"
    return this.state.pricesBySort[key] || []
  }

  getRankingStoresPath() {
    return this.props.ranking_stores_path || this.props.rankingStoresPath
  }

  fetchRankingStores(sort, page) {
    const path = this.getRankingStoresPath()
    if (!path) return Promise.resolve({ prices: [], total_count: 0 })
    const sep = path.indexOf("?") >= 0 ? "&" : "?"
    const excludeIds = this.props.exclude_pr_store_ids || this.props.excludePrStoreIds || []
    const excludeQuery = Array.isArray(excludeIds) && excludeIds.length > 0
      ? "&" + excludeIds.map((id) => `exclude_pr_store_ids[]=${encodeURIComponent(id)}`).join("&")
      : ""
    const url = `${path}${sep}sort=${sort}&page=${page}${excludeQuery}`
    return fetch(url, { headers: { Accept: "application/json" } })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        return res.json()
      })
      .then((json) => ({ prices: json.prices || [], total_count: json.total_count }))
  }

  loadMoreForCurrentTab() {
    const sort = this.state.currentSortKey || "recommend"
    const nextPage = this.state.pageBySort[sort] + 1
    this.setState({ loading: true })
    this.fetchRankingStores(sort, nextPage)
      .then(({ prices, total_count }) => {
        const key = sort
        this.setState((prev) => {
          const currentList = prev.pricesBySort[key] || []
          const existingIds = new Set(currentList.map((p) => p.store && p.store.id))
          const newItems = (prices || []).filter((p) => p.store && !existingIds.has(p.store.id))
          const merged = [...currentList, ...newItems]
          return {
            pricesBySort: { ...prev.pricesBySort, [key]: merged },
            pageBySort: { ...prev.pageBySort, [key]: nextPage },
            totalCount: total_count != null ? total_count : prev.totalCount,
            maxShowCount: merged.length,
            loading: false,
          }
        })
      })
      .catch((err) => {
        console.error("ranking_stores fetch failed", err)
        this.setState({ loading: false })
      })
  }

  ensureTabData(sortKey) {
    const key = sortKey || "recommend"
    const path = this.getRankingStoresPath()
    if (!path) return
    const list = this.state.pricesBySort[key] || []
    if (list.length > 0 || this.state.totalCount <= 0 || this.state.loading) return
    this.setState({ loading: true })
    this.fetchRankingStores(key, 1)
      .then(({ prices, total_count }) => {
        this.setState((prev) => ({
          pricesBySort: { ...prev.pricesBySort, [key]: prices || [] },
          pageBySort: { ...prev.pageBySort, [key]: 1 },
          totalCount: total_count != null ? total_count : prev.totalCount,
          maxShowCount: Math.max(prev.maxShowCount, (prices || []).length),
          loading: false,
        }))
      })
      .catch(() => this.setState({ loading: false }))
  }

  resetSort() {
    this.setState({ currentSortKey: "" })
  }

  sortByReview() {
    this.setState({ currentSortKey: "review" }, () => this.ensureTabData("review"))
  }

  sortByPrice() {
    this.setState({ currentSortKey: "price" }, () => this.ensureTabData("price"))
  }

  onLoadBtnClick(e) {
    if (e && e.preventDefault) e.preventDefault()
    const list = this.getCurrentList()
    const total = this.state.totalCount
    const path = this.getRankingStoresPath()
    if (path && list.length < total) {
      this.loadMoreForCurrentTab()
      return
    }
    if (list.length <= this.state.maxShowCount) {
      this.setState({ maxShowCount: this.state.loadCount })
      return
    }
    this.setState({ maxShowCount: this.state.maxShowCount + this.state.loadCount })
  }

  getLoadBtnText() {
    const list = this.getCurrentList()
    const total = this.state.totalCount
    const path = this.getRankingStoresPath()
    if (path && list.length < total) {
      return (list.length + 1) + "位以下を見る"
    }
    if (list.length <= this.state.maxShowCount) {
      return "閉じる"
    }
    return (this.state.maxShowCount + 1) + "位以下を見る"
  }

  UNSAFE_componentWillMount() {
    const loadCount = this.props.load_count
    if (loadCount && 1 < loadCount) {
      this.setState({ loadCount: loadCount, maxShowCount: loadCount })
    }
  }

  update() {
    if (typeof window.hika_sp_popup_init === 'function') {
      window.hika_sp_popup_init()
    }
    if (window.jQuery !== undefined) {
      let obj = $('.item__ranking__list')
      if (window.jQuery.review_star !== undefined) {
        window.jQuery.review_star.set_star_size(obj)
      }
    }
  }

  componentDidMount() {
    this.update()
  }

  componentDidUpdate() {
    this.update()
  }

  getLoadBtn() {
    const list = this.getCurrentList()
    const total = this.state.totalCount
    const path = this.getRankingStoresPath()
    const hasMoreFromApi = path && list.length < total
    const hasMoreShown = list.length > this.state.maxShowCount
    if (!hasMoreFromApi && !hasMoreShown) {
      return ""
    }
    return (
      <div id="next" className="">
        <button
          type="button"
          className="btn-link item__ranking__loadmore"
          onClick={this.onLoadBtnClick}
          disabled={this.state.loading}
        >
          {this.state.loading ? (
            <span className="btn-low fnt-size-10">読み込み中...</span>
          ) : (
            <span className="btn-low fnt-size-10">{ this.getLoadBtnText()}</span>
          )}
        </button>
      </div>
    )
  }

  /*@brief ランキングヘッダーを返す*/
  getRankingHeader() {
    return (
      <ul className="tabbar two">
        <li className={ "tabbar__cell " + ((this.state.currentSortKey === "") ? "active" : "")}>
          <button className="tabbar__cellbtn" id="toggle-ranking-sort-normal" onClick={this.resetSort}>{this.RECOMMEND_SORT_LABEL}</button>
        </li>
        <li className={ "tabbar__cell " + ((this.state.currentSortKey === "price") ? "active" : "")}>
          <button className="tabbar__cellbtn" id="toggle-ranking-sort-normal" onClick={this.sortByPrice}>{this.PRICE_SORT_LABEL}</button>
        </li>
        <li className={ "tabbar__cell " + ((this.state.currentSortKey === "review") ? "active" : "")}>
          <button className="tabbar__cellbtn" id="toggle-ranking-sort-review" onClick={this.sortByReview}>{this.REVIEW_SORT_LABEL}</button>
        </li>
      </ul>
    )
  }

  getRankingSelect() {
    return (
      <div className="item__ranking__header">
        <select
          value={this.state.currentSortKey}
          onChange={(e) => {
            const key = e.target.value
            this.setState({ currentSortKey: key }, () => this.ensureTabData(key || "recommend"))
          }}
          className="item__ranking__header__select"
        >
          <option value="">{this.RECOMMEND_SORT_LABEL}</option>
          <option value="price">{this.PRICE_SORT_LABEL}</option>
          <option value="review">{this.REVIEW_SORT_LABEL}</option>
        </select>
      </div>
    )
  }

  render() {
    const store = this.props
    const list = this.getCurrentList()
    const sortKey = this.state.sortKeys[this.state.currentSortKey]
    const targetList = (!this.getRankingStoresPath() && sortKey) ? Util.objectArraySort(_.cloneDeep(list), sortKey) : list
    const displayList = targetList.slice(0, this.state.maxShowCount)
    const total = this.state.totalCount
    const elms = displayList.map((obj, index) => (
      <RankingCellSingleProduct
        key={obj.store ? obj.store.id + "-" + index : index}
        index={index}
        data={obj}
        item={store.data.item}
        highestPrice={this.state.highestPrice}
        isMobile={store.is_mobile}
      />
    ))
    const loadBtn = this.getLoadBtn()
    return (
      <div>
        {store.is_mobile ? this.getRankingSelect() : this.getRankingHeader()}
        <ul className="item__ranking__list">
          {this.props.data.pr_prices.map((price) => (
            <RankingCellSingleProduct
              pr
              key={price.store.id}
              data={price}
              item={this.props.data.item}
              highestPrice={this.state.highestPrice}
              isMobile={store.is_mobile}/>
          ))}
          {this.state.loading && list.length === 0 ? (
            <li className="item__ranking__cell"><span className="fnt-size-10">読み込み中...</span></li>
          ) : null}
          {elms}
        </ul>
        <div>
          <div className="alignright">
            <span className="paged_number fnt-size-10 ">
              { Math.min(displayList.length, total) + "/" + total + "件表示中"}
            </span>
          </div>
          <div className="alignright item__ranking__loadmore-wrap">
            {loadBtn}
          </div>
        </div>
      </div>
    )
  }
}

export default RankingListSingleProduct
